import React from 'react'
import {IconSlot, StyledIconButton} from "src/components/views/mkt04/Button/styled";
import {Spinner} from "src/components/views/mkt04/Button/index";

type BtnHTML = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'>
    & { type?: 'button' }

type IconButtonProps = BtnHTML & {
    name?: string
    isLoading?: boolean
    icon?: React.ReactNode
    iconSrc?: string
    iconAlt?: string
    iconPosition?: 'left' | 'right'
    iconSize?: number
    iconGap?: number
    iconInline?: boolean   
}

export const IconButton: React.FC<IconButtonProps> = ({
                                                          name,
                                                          children,
                                                          isLoading = false,
                                                          disabled,
                                                          icon,
                                                          iconSrc,
                                                          iconAlt = '',
                                                          iconPosition = 'right',
                                                          iconSize = 24,
                                                          iconGap = 8,
                                                          iconInline = false,  
                                                          className,
                                                          type = 'button',
                                                          ...rest
                                                      }) => {
    const label = children ?? name

    return (
        <StyledIconButton
            {...rest}
            className={className}
            type={type}
            disabled={disabled || isLoading}
            isLoading={isLoading}
            aria-busy={isLoading}
            $iconPosition={iconPosition}
            $iconSize={iconSize}
            $iconGap={iconGap}
            $iconInline={iconInline}  
        >
            {isLoading && <Spinner />}


            {!isLoading && label}

           {!isLoading && (
        <>
          {iconInline && (icon || iconSrc) && iconPosition === 'left' && (
            <IconSlot
              aria-hidden="true"
              $iconPosition="left"
              $iconSize={iconSize}
              $iconGap={iconGap}
              $iconInline
            >
              {icon ?? <img src={iconSrc!} alt={iconAlt} />}
            </IconSlot>
          )}

          {iconInline && (icon || iconSrc) && iconPosition === 'right' && (
            <IconSlot
              aria-hidden="true"
              $iconPosition="right"
              $iconSize={iconSize}
              $iconGap={iconGap}
              $iconInline
            >
              {icon ?? <img src={iconSrc!} alt={iconAlt} />}
            </IconSlot>
          )}
          
          {!iconInline && (icon || iconSrc) && (
            <IconSlot
              aria-hidden="true"
              $iconPosition={iconPosition}
              $iconSize={iconSize}
              $iconGap={iconGap}
            >
              {icon ?? <img src={iconSrc!} alt={iconAlt} />}
            </IconSlot>
          )}
        </>
      )}
        </StyledIconButton>
    )
}
